import { render, staticRenderFns } from "./examSession.vue?vue&type=template&id=efd12942&scoped=true"
import script from "./examSession.vue?vue&type=script&lang=js"
export * from "./examSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd12942",
  null
  
)

export default component.exports